function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.22039 12.8869C2.00179 12.1055 3.0616 11.6665 4.16667 11.6665H10.8333C11.9384 11.6665 12.9982 12.1055 13.7796 12.8869C14.561 13.6683 15 14.7281 15 15.8332V17.4998C15 17.9601 14.6269 18.3332 14.1667 18.3332C13.7064 18.3332 13.3333 17.9601 13.3333 17.4998V15.8332C13.3333 15.1701 13.0699 14.5342 12.6011 14.0654C12.1323 13.5966 11.4964 13.3332 10.8333 13.3332H4.16667C3.50363 13.3332 2.86774 13.5966 2.3989 14.0654C1.93006 14.5342 1.66667 15.1701 1.66667 15.8332V17.4998C1.66667 17.9601 1.29357 18.3332 0.833333 18.3332C0.373096 18.3332 0 17.9601 0 17.4998V15.8332C0 14.7281 0.438987 13.6683 1.22039 12.8869Z",
  fill: "#C7E8FE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.50065 3.33317C6.11994 3.33317 5.00065 4.45246 5.00065 5.83317C5.00065 7.21388 6.11994 8.33317 7.50065 8.33317C8.88136 8.33317 10.0006 7.21388 10.0006 5.83317C10.0006 4.45246 8.88136 3.33317 7.50065 3.33317ZM3.33398 5.83317C3.33398 3.53198 5.19946 1.6665 7.50065 1.6665C9.80184 1.6665 11.6673 3.53198 11.6673 5.83317C11.6673 8.13436 9.80184 9.99984 7.50065 9.99984C5.19946 9.99984 3.33398 8.13436 3.33398 5.83317Z",
  fill: "#C7E8FE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8606 12.4001C15.9757 11.9545 16.4302 11.6865 16.8759 11.8016C17.7697 12.0324 18.5617 12.5535 19.1273 13.2831C19.6929 14.0128 20.0002 14.9096 20.0009 15.8328L20.0009 17.5001C20.0009 17.9603 19.6278 18.3334 19.1675 18.3334C18.7073 18.3334 18.3342 17.9603 18.3342 17.5001L18.3342 15.8341C18.3342 15.834 18.3342 15.8341 18.3342 15.8341C18.3337 15.2802 18.1494 14.742 17.81 14.3043C17.4707 13.8665 16.9955 13.5538 16.4592 13.4153C16.0136 13.3003 15.7456 12.8457 15.8606 12.4001Z",
  fill: "#C7E8FE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5262 2.40174C12.6404 1.95588 13.0944 1.68699 13.5402 1.80114C14.4365 2.03062 15.2309 2.55187 15.7982 3.28272C16.3655 4.01356 16.6734 4.91243 16.6734 5.8376C16.6734 6.76278 16.3655 7.66164 15.7982 8.39249C15.2309 9.12333 14.4365 9.64458 13.5402 9.87406C13.0944 9.98822 12.6404 9.71932 12.5262 9.27347C12.4121 8.82761 12.681 8.37363 13.1268 8.25948C13.6646 8.12179 14.1412 7.80904 14.4816 7.37053C14.822 6.93203 15.0067 6.39271 15.0067 5.8376C15.0067 5.2825 14.822 4.74318 14.4816 4.30467C14.1412 3.86617 13.6646 3.55342 13.1268 3.41573C12.681 3.30157 12.4121 2.84759 12.5262 2.40174Z",
  fill: "#C7E8FE"
});

var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users.6f60f722.svg";
export { ForwardRef as ReactComponent };